var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 19.973V3.457C.5 1.485 2.675.29 4.34 1.346l14.07 8.928c1.612 1.023 1.528 3.404-.153 4.31l-14.07 7.59C2.52 23.072.5 21.866.5 19.974z",
    fill: "#fff",
    fillOpacity: 0.5,
    stroke: "url(#playVideoIcon_svg__paint0_linear_5975:7457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playVideoIcon_svg__paint0_linear_5975:7457",
    x1: 23.605,
    y1: 12.727,
    x2: -3.833,
    y2: 12.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

export default SvgPlayVideoIcon;